import { VStack, Box, Flex, FormLabel, Spacer, UnorderedList, ListItem} from '@chakra-ui/react'
import { Card } from 'components/card/card'
import { Link } from 'react-router-dom'; 

const ReportsDashboard = () => {return (
  <div>
    {/* The hyperlink element */}

    <VStack alignItems="start" minH="calc(100vh - 160px)" pb="2">
        <Card
          w="100%"
          py="14px"
          px="14px"
          boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
        >
          <Flex w="100%" mb="14px" alignItems={'center'}>
            <FormLabel variant="strong-label" size="lg" whiteSpace="nowrap" m="0" fontSize="18px">
            <h2>Maintenance Portal - Reports</h2>
            </FormLabel>
            <Spacer />
          </Flex>

          <Box w="100%" minH="500px">
          <UnorderedList spacing={2} padding={4}>
              <ListItem>
                <Link to="/reports?dashboardId=853b9f03-d2af-455f-9918-fab808f2bbd3">
                  Profit Margin per Month
                  </Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=391bb314-874e-4b09-bbfb-afc76edb7d1e">
                Net Profit per Month
                </Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=b0d78c83-efc1-4c38-8c56-994f638cdd65">
                  Revenue per Month
                  </Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=0ebd903f-21d0-4324-8ede-92a98e008f19">
                  Revenue vs Profit
                  </Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=3c8bdfc1-6196-4d60-a37d-85760ca0b99e">Financials Overview Ticket Wise</Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=fdace4e5-b8dd-4a60-9fb9-38978cd06a88">Financials Overview Property Wise</Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=39862b57-c7cc-47b9-bfa4-0f229caf7e75">Performance</Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=52220823-46ea-4d6e-9186-8d07d1ad5209">Ticket Status per Month</Link>
              </ListItem>
              <ListItem>
                <Link to="/reports?dashboardId=a5f5ce80-64da-49b8-a266-1c358e9b9f45">Tickets per Client</Link>
              </ListItem>
            </UnorderedList>
          </Box>
        </Card>
    </VStack>
  </div>
);
};


export default ReportsDashboard
